(function() {
  class AnimatedDetails extends HTMLElement {
    constructor() {
      super();
      this.mainDetailsToggle = this.querySelector('details');
      this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;
      this.mainDetailsToggle.querySelector('summary').addEventListener('click', this.onSummaryClick.bind(this));
    }

    onSummaryClick(event) {
      event.preventDefault();
      if (this.mainDetailsToggle.hasAttribute('open')) {
        this.animate('close');
      } else {
        this.mainDetailsToggle.setAttribute('open', '');
        this.animate('open');
      }
    }

    animate(action) {
      const maxHeight = this.content.scrollHeight + 'px';
      const keyframes =
        action === 'open'
          ? [
              { maxHeight: '0', overflow: 'hidden' },
              { maxHeight: maxHeight, overflow: 'hidden' },
            ]
          : [
              { maxHeight: maxHeight, overflow: 'hidden' },
              { maxHeight: '0', overflow: 'hidden' },
            ];

      const animation = this.content.animate(keyframes, {
        duration: 250,
        easing: action === 'open' ? 'ease-out' : 'ease-in',
        fill: 'both',
      });

      if (action === 'close') {
        animation.onfinish = () => {
          this.mainDetailsToggle.removeAttribute('open');
        };
      }
    }
  }

  customElements.define('animated-details', AnimatedDetails);
})();
